// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button{border:none}.scrollUpButton-04HsK{position:fixed !important;bottom:20px;right:20px;background-color:#fff !important;border-radius:6px !important;box-shadow:0 0 10px rgba(0,0,0,.2);color:#fff;border:none;width:44px;height:44px;display:flex;justify-content:center;align-items:center;cursor:pointer;z-index:3 !important;opacity:0;pointer-events:none;transition:.3s ease all}.scrollUpButton-04HsK:hover{background-color:#00d88f}.scrollUpButton-04HsK.show-DDQx3{opacity:1;pointer-events:auto}.icon-vsg91{width:20px;height:20px;fill:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollUpButton": "scrollUpButton-04HsK",
	"show": "show-DDQx3",
	"icon": "icon-vsg91"
};
export default ___CSS_LOADER_EXPORT___;
